var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.99px",
    height: "15.99px",
    viewBox: "79.1 119.854 15.99 15.99",
    enableBackground: "new 79.1 119.854 15.99 15.99",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M87.095,119.854c-4.408,0-7.995,3.587-7.995,7.995s3.587,7.995,7.995,7.995s7.995-3.587,7.995-7.995 S91.503,119.854,87.095,119.854z M91.99,122.867h-9.791c1.263-1.24,2.99-2.008,4.896-2.008 C89,120.859,90.728,121.627,91.99,122.867z M87.747,125.015c0,0.25-0.204,0.454-0.455,0.454c-0.25,0-0.452-0.204-0.452-0.454 s0.202-0.455,0.452-0.455C87.543,124.56,87.747,124.765,87.747,125.015z M87.292,126.474c0.804,0,1.46-0.654,1.46-1.459 c0-0.465-0.223-0.875-0.563-1.143h2.798v3.924l-1.684-1.238l-2.167,2.749l-2.42-2.188l-1.767,1.406v-4.652h3.448 c-0.34,0.268-0.562,0.678-0.562,1.143C85.835,125.82,86.488,126.474,87.292,126.474z M82.949,129.808l1.726-1.372l1.838,1.663 l-1.427,1.811h-2.137V129.808z M89.491,127.943l1.495,1.1v2.867h-4.621L89.491,127.943z M80.104,127.849 c0-1.816,0.702-3.467,1.841-4.711v9.422C80.805,131.316,80.104,129.665,80.104,127.849z M82.291,132.915h9.607 c-1.254,1.189-2.942,1.925-4.803,1.925S83.544,134.104,82.291,132.915z M91.991,132.83v-9.961c1.291,1.269,2.094,3.031,2.094,4.98 C94.085,129.798,93.282,131.561,91.991,132.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcon01);
export default __webpack_public_path__ + "static/media/icon_icon-01.7c46f184cb4275f264c2e76a2f4a3895.svg";
export { ForwardRef as ReactComponent };